import { useId, type ReactNode, type Ref } from 'react';

export function AiSurface({
  busy,
  className,
  children,
  ref,
  'data-testid': testId,
}: {
  busy?: boolean;
  className?: string;
  children: ReactNode;
  ref?: Ref<HTMLDivElement>;
  'data-testid'?: string;
}) {
  const classes = ['ai-surface', busy && 'ai-surface--busy', className].filter(Boolean);
  return (
    <div ref={ref} className={classes.join(' ')} data-testid={testId}>
      <span className="ai-surface__glow" aria-hidden="true">
        <span />
      </span>
      <span className="ai-surface__ring" aria-hidden="true">
        <span />
      </span>
      <div className="ai-surface__body">{children}</div>
    </div>
  );
}

export function AiSparkle({ size = 18 }: { size?: number }) {
  const gradientId = `ai-sparkle-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
  return (
    <svg
      className="ai-sparkle"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" style={{ stopColor: 'var(--ai-c4)' }} />
          <stop offset="0.55" style={{ stopColor: 'var(--ai-c5)' }} />
          <stop offset="1" style={{ stopColor: 'var(--ai-c6)' }} />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradientId})`}
        d="M10 2.5c.4 3.9 2.6 6.1 6.5 6.5-3.9.4-6.1 2.6-6.5 6.5-.4-3.9-2.6-6.1-6.5-6.5 3.9-.4 6.1-2.6 6.5-6.5Zm8 10c.25 2.2 1.3 3.25 3.5 3.5-2.2.25-3.25 1.3-3.5 3.5-.25-2.2-1.3-3.25-3.5-3.5 2.2-.25 3.25-1.3 3.5-3.5Z"
      />
    </svg>
  );
}
